import normalize from "json-api-normalizer";
import store from "@/store/index";
import { decamelize } from "humps";

import BaseService from "./BaseService";

export default {
  status(type) {
    const statuses = {
      upcoming: 0,
      unsigned: 1,
      completed: 2
    };

    return statuses[type];
  },

  load(params) {
    let query = `sort=${params.sortDir}${params.sorted}&filter=status=${
      params.status
    }&signed=${params.signed}`;
    query += `&page[number]=${params.pageNumber}`;

    return BaseService.get(`encounters?${query}`)
      .then(response => {
        let type = "setUpcoming";
        if (params.status === this.status("unsigned")) {
          type = "setUnsigned";
        } else if (params.status === this.status("completed")) {
          type = "setCompleted";
        }
        store.dispatch(`encounter/${type}`, {
          list: normalize(response.data),
          links: response.data.links
        });
      })
      .catch(errors => Promise.reject(errors));
  },

  create(values) {
    return BaseService.post("encounters", "encounters", values)
      .then(() => Promise.resolve())
      .catch(errors => Promise.reject(errors));
  },

  update(values) {
    return BaseService.patch("encounters", `encounters/${values.id}`, values)
      .then(() => Promise.resolve())
      .catch(errors => Promise.reject(errors));
  },

  saveNotes(values) {
    return BaseService.patch(
      "encounters",
      `encounters/${values.id}/notes`,
      values
    )
      .then(() => Promise.resolve())
      .catch(errors => Promise.reject(errors));
  },

  delete(id) {
    return BaseService.delete(`encounters/${id}`)
      .then(() => Promise.resolve())
      .catch(errors => Promise.reject(errors));
  },

  getDetails(id) {
    return BaseService.get(`encounters/${id}`)
      .then(response => this.prepareEncounter(response))
      .catch(errors => Promise.reject(errors));
  },

  getToken(id) {
    return BaseService.get(`encounters/${id}/token`)
      .then(response => {
        return response.data.token;
      })
      .catch(errors => Promise.reject(errors));
  },

  prepareEncounter(response) {
    const responseData = normalize(response.data);
    const encounter =
      responseData.encounters[Object.keys(responseData.encounters)[0]];
    encounter.relationships.patient =
      responseData.patients[encounter.relationships.patient.data.id];
    encounter.relationships.provider =
      responseData.users[encounter.relationships.provider.data.id];
    encounter.relationships.interviewImages = responseData.interviewImages;
    return encounter;
  },

  updateFaceData(id, field, value) {
    const values = { id, value, field: decamelize(field) };
    return BaseService.patch(
      "encounters",
      `encounters/${values.id}/face-data`,
      values
    )
      .then(response => this.prepareEncounter(response))
      .catch(errors => Promise.reject(errors));
  },

  getInsurance() {
    return BaseService.get("interviews/insurance")
      .then(response => response.data)
      .catch(errors => Promise.reject(errors));
  },

  startArchive(id) {
    return BaseService.patch("encounters", `encounters/${id}/start-archive`, {
      id
    })
      .then(() => Promise.resolve())
      .catch(errors => Promise.reject(errors));
  },

  stopSession(id) {
    return BaseService.patch("encounters", `encounters/${id}/stop`, { id })
      .then(() => Promise.resolve())
      .catch(errors => Promise.reject(errors));
  },

  signSession(id) {
    return BaseService.patch("encounters", `encounters/${id}/sign`, { id })
      .then(() => Promise.resolve())
      .catch(errors => Promise.reject(errors));
  }
};
